import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { EventReservationResource } from 'src/app/interfaces/event-reservation-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { Sort } from '@angular/material/sort';
/**
 * See the SB PART => is the same
 * @ignore 
 */
@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<any>;
  displayedColumns = ['select', 'voucherKey', 'event.title', 'attendingAccount.displayName', 'created', 'state', 'paymentstate', 'menu']; //'Kontaktdaten',

  page = null;
  filterForm: UntypedFormGroup;
  showMoreFilter: boolean = false;
  selectedAll: boolean = false;
  canPrintAllReservations: boolean = false;
  canUseAllReservations: boolean = false;
  canCancelAllReservations: boolean = false;
  canCancelAllVouchers: boolean = false;

  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  eventStates = [
    { value: 'DRAFT', viewValue: 'Entwurf' },
    { value: 'PREVIEW', viewValue: 'Vorschau' },
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'HIDDEN', viewValue: 'Versteckt' },
    { value: 'CANCELLED', viewValue: 'Abgelehnt' },
    { value: 'EXPIRED', viewValue: 'Abgelaufen' },
    { value: 'ARCHIVED', viewValue: 'Archiviert' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
    { value: "CREATED", viewValue: "Aktiv" }
  ]

  paymentStates = [
    { value: "NO_PAYMENT", viewValue: "Kostenlos" },
    { value: "PENDING", viewValue: "Nicht bezahlt" },
    { value: "INVOICED", viewValue: "Zugestellt" },
    { value: "PAID", viewValue: "Bezahlt" },
    { value: "CANCELLED", viewValue: "Storniert" }
  ]

  States = [
    { value: "RESERVED", viewValue: "Reserviert" },
    { value: "CANCELLED", viewValue: "Storniert" },
    { value: "USED", viewValue: "Eingelöst" },
    { value: "NEW", viewValue: "Neu" },
    { value: "FAILED", viewValue: "Fehler" },
    { value: "EXPIRED", viewValue: "Ausgelaufen" },
    { value: "REJECTED", viewValue: "Abgelehnt" }
  ]

  partners = [];
  selectedReservations = [];

  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder,
    private overlay: OverlayService,
    private router: Router,
    private route:ActivatedRoute) {
    this.filterForm = this.fb.group({
      customerPublicIds: null,
      eventPartnerPublicIds: null,
      eventPublicId: null,
      eventStates: null,
      filterByPaymentStates: null,
      filterByStates: null,
      searchTerm: null,
      voucherKey: null
    })

    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content
    })

    let extras = this.router.getCurrentNavigation()?.extras?.state;
    if (extras) {
      console.log(extras)
      this.filterForm.markAllAsTouched();
      console.log(extras.eventPartnerPublicIds)
      this.filterForm.patchValue({
        eventPublicId: extras.eventPublicId,
      })
    }





  }

  ngOnInit() {
    this.eventService.searchForEventReservationsV1(this.pageData.pageIndex, this.pageData.pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
      console.log("EVENTS Search: ", push)
      this.page = push.page
      push.content.forEach(newelement => {
        this.selectedReservations.forEach(element => {
          if (newelement.publicId == element.publicId) {
            if (element['selected'] == true) {
              newelement['selected'] = true;
            } else {
              newelement['selected'] = false;
            }
          }
        });
      });
      this.dataSource = new MatTableDataSource(push.content);
    })
  }

  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  search(pageIndex, pageSize) {

    this.eventService.searchForEventReservationsV1(pageIndex, pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
      this.page = push.page
      this.pageData.pageIndex = pageIndex;
      this.pageData.pageSize = pageSize;
      push.content.forEach(newelement => {
        this.selectedReservations.forEach(element => {
          if (newelement.publicId == element.publicId) {
            if (element['selected'] == true) {
              newelement['selected'] = true;
            } else {
              newelement['selected'] = false;
            }
          }
        });
      });
      this.dataSource = new MatTableDataSource(push.content);
    })
  }


  filterReservations() {

    let eventPartnerPublicIds = [];
    if (this.filterForm.value.eventPartnerPublicIds != null) {
      if (this.filterForm.value.eventPartnerPublicIds?.length != 0) {
        this.filterForm.value.eventPartnerPublicIds.forEach(element => {
          eventPartnerPublicIds.push(element.publicId);
        });
      }
    }

    this.eventService.searchForEventReservationsV1(this.pageData.pageIndex, this.pageData.pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
      this.page = push.page
      push.content.forEach(element => {
        element['selected'] = false;
      });
      this.selectedAll = false;
      this.selectedReservations = [];
      this.dataSource = new MatTableDataSource(push.content);

    })
  }

  showmoreFilters() {
    this.showMoreFilter = true;
  }

  showLessFilters() {
    this.showMoreFilter = false;
  }

  resetFilter() {
    this.filterForm.reset();
    this.search(this.pageData.pageIndex, this.pageData.pageSize);
  }

  ngAfterViewInit() {
    //Look for change on the sort Headers
    this.sort.sortChange.subscribe(value => {
      if (value.direction == '') {
        this.dataSource = new MatTableDataSource(this.fisherYatesShuffle(this.dataSource.data));
      } else {
        this.eventService.searchForEventReservationsV1(this.pageData.pageIndex, this.pageData.pageSize, value.active + "," + value.direction, this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element['selected'] = false;
          });
          this.dataSource = new MatTableDataSource(push.content);
          this.selectedAll = false;
          this.selectedReservations = [];
        })
      }
    })

  }

  getPDF(resID) {
    this.eventService.getPDF(resID).subscribe(blob => {
      console.log(blob)
      var file = new Blob([blob], { type: 'application/pdf' });
      let pdf = URL.createObjectURL(file);
      window.open(pdf)
    })
  }

  delteReservation(resID) {
    this.eventService.delteReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Gutschein erfolgreich storniert!");
        this.filterReservations();
      }
    })
  }

  delteAlreadyUsesReservation(resID) {
    this.eventService.delteAlreadyUsesReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Einlösung erfolgreich storniert!");
        this.filterReservations();
      }
    })
  }


  useReservation(resID) {
    this.eventService.useReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Gutschein erfolgreich eingelöst!");
        this.filterReservations();
      }
    })
  }


  canUse(reservation) {
    return reservation.state === 'RESERVED';
  };

  canCancelReservationUsage(reservation) {
    return reservation.state === 'USED';
  };

  canPrint(reservation) {
    return reservation.state !== 'CANCELLED';
  };

  canCancel(reservation) {
    return reservation.state === 'RESERVED' && (
      reservation.paymentState === 'NO_PAYMENT' ||
      reservation.paymentState === 'INVOICED' ||
      reservation.paymentState === 'PENDING'
    );
  }


  selectReservation(res: EventReservationResource) {
    if (this.selectedReservations.filter(function (e) { return e.publicId === res.publicId; }).length > 0) {
      res['selected'] = false;
      this.selectedReservations.splice(this.selectedReservations.indexOf(res), 1);
    } else {
      res['selected'] = true;
      this.selectedReservations.push(res);
    }

    this.genValuesForAll();
  }

  selectAll() {
    this.selectedReservations = [];
    if (this.selectedAll) {
      this.dataSource.data.forEach(element => {
        this.selectedReservations.splice(this.selectedReservations.indexOf(element), 1);
        element['selected'] = false;
        this.selectedAll = false;
      });
    } else {
      this.dataSource.data.forEach(element => {
        this.selectedReservations.push(element);
        element['selected'] = true;
        this.selectedAll = true;
        this.genValuesForAll();
      });
    }

    if (this.selectedReservations.length == 0) {
      this.canCancelAllVouchers = false;
      this.canCancelAllReservations = false;
      this.canUseAllReservations = false;
      this.canPrintAllReservations = false;
    }
  }

  printAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.getPDF(element.publicId);
    });
  }


  cancelAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.delteAlreadyUsesReservation(element.publicId);
    });
  }

  cancelAllVouchers() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.delteReservation(element.publicId);
    });
  }

  useAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.useReservation(element.publicId);
    });
  }


  genValuesForAll() {
    if (this.selectedReservations.length != 0) {
      this.canPrintAllReservations = this.selectedReservations.every(function (e) {
        if (e.state !== 'CANCELLED') {
          return true;
        } else {
          return false;
        }
      });

      this.canUseAllReservations = this.selectedReservations.every(function (e) {
        if (e.state === 'RESERVED') {
          return true;
        } else {
          return false;
        }
      });

      this.canCancelAllReservations = this.selectedReservations.every(function (e) {
        if (e.state === 'USED') {
          return true;
        } else {
          return false;
        }
      });


      this.canCancelAllVouchers = this.selectedReservations.every(function (e) {
        if (e.state === 'RESERVED' && (e.paymentState === 'NO_PAYMENT' || e.paymentState === 'INVOICED' || e.paymentState === 'PENDING')) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      this.canCancelAllVouchers = false;
      this.canCancelAllReservations = false;
      this.canUseAllReservations = false;
      this.canPrintAllReservations = false;
    }
  }

  fisherYatesShuffle(arr) {

    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)); //random index
      [arr[i], arr[j]] = [arr[j], arr[i]]; // swap
    }

    return arr;
  }

}

